import { Box, Button, Flex, Text, theme } from '@xometry/xometry_loft';
import React from 'react';
import { WWW_ORIGIN } from '../../../../config';

const IncompleteLinkPage = () => {
  return (
    <Flex flexDirection="column" alignItems="center" justifyContent="center">
      <img
        src={`https://assets.xometry.com/spot-error.svg`}
        alt="Accept Organization Invitation"
      />
      <Box
        flexDirection="column"
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="440px"
      >
        <Text
          kind="body-title"
          mb={theme.space[2]}
          color={theme.colors.darkBlues[100]}
        >
          Incomplete Invitation Link
        </Text>
        <Text
          kind="body-sm"
          textAlign="center"
          color={theme.colors.darkBlues[75]}
        >
          {
            'Go back to your invitation email to accept again, or go to Account Settings>Teams>Pending Invitations to accept.'
          }
        </Text>
      </Box>
      <Button
        kind="primary"
        mt={theme.space[10]}
        paddingX={theme.space[3]}
        paddingY={theme.space[2]}
        onClick={() => window.location.assign(`${WWW_ORIGIN}/user-settings`)}
      >
        Go to Account Settings
      </Button>
    </Flex>
  );
};

export default IncompleteLinkPage;
